import { Organisation } from '@/common/global.interfaces';

export enum GRANT_SECTION {
  AGENT = 'Agent'
}

export interface Accessibles {
  units: {
    unitId: number;
    panel: number;
  }[];
  volunteer: boolean;
  administration: boolean;
  organisations: Organisation[];
}

export interface GrantPermission {
  unitId?: number;
}

export type Grants = Partial<
  Record<GRANT_SECTION, Record<string, GrantPermission[]>>
>;
